class ScriptVideoOverlay {
	constructor(parent, allPlayers) {
		this.section = parent
		this.playButton = parent.querySelector(".media-block_video-img")
		this.player = new Vimeo.Player(parent.querySelector(".media-block_video-iframe"))
		this.allPlayers = allPlayers

		this.playButton.addEventListener("click", () => {
			this.pauseOtherVideos()
			this.player.play().catch(() => {
				this.player.play()
			})
			this.showPlayer()
		})

		this.player.on("play", () => {
			this.pauseOtherVideos()
		})
	}

	pauseOtherVideos() {
		this.allPlayers.forEach(player => {
			if (player !== this.player) {
				player.pause().catch(() => {})
			}
		})
	}

	showPlayer() {
		this.section.classList.add("opened")
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const videoSections = document.querySelectorAll(".media-block_video")
	const allPlayers = Array.from(videoSections).map(section => new Vimeo.Player(section.querySelector(".media-block_video-iframe")))

	videoSections.forEach((section, index) => {
		new ScriptVideoOverlay(section, allPlayers)
	})
})
